import { render } from "./HelixMenus.vue?vue&type=template&id=09507154&scoped=true"
import script from "./HelixMenus.vue?vue&type=script&lang=js"
export * from "./HelixMenus.vue?vue&type=script&lang=js"

import "./HelixMenus.vue?vue&type=style&index=0&id=09507154&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09507154"]])

export default __exports__